export class TimePickerPeriod {
  value: string;

  constructor(value: string) {
    this.value = value;
  }
}
